import * as React from "react";
import {
    Divider,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    styled,
} from "@mui/material";
import { Routes } from "config";
import { Folder, SettingsSharp } from "@mui/icons-material";
import { useAppDispatch } from "#store";
import { H1 } from "#common/headings";
import { push } from "redux-first-history";

const Offset = styled("div")(({ theme }) => {
    return {
        ...theme.mixins.toolbar,
    };
});

type Props = {
    onClick: () => void;
};
export const AppDrawer = ({ onClick }: Props) => {
    const dispatch = useAppDispatch();

    return (
        <Offset>
            <H1>Menu</H1>
            <List>
                <ListItemButton
                    key={Routes.settings.path}
                    onClick={() => {
                        dispatch(push(Routes.settings.path));
                        onClick();
                    }}
                >
                    <ListItemIcon>
                        <SettingsSharp />
                    </ListItemIcon>
                    <ListItemText primary={Routes.settings.label} />
                </ListItemButton>
                <Divider />
                <ListItem disablePadding>
                    <ListItemButton
                        component="a"
                        href="http://testbed.inode.igd.fraunhofer.de:18000/"
                        onClick={() => onClick()}
                    >
                        <ListItemText primary="CORDIS SPARQL Portal" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        component="a"
                        href="http://testbed.inode.igd.fraunhofer.de:18006/"
                        onClick={() => onClick()}
                    >
                        <ListItemText primary="SDSS SPARQL Portal" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        component="a"
                        href="http://testbed.inode.igd.fraunhofer.de:18005/"
                        onClick={() => onClick()}
                    >
                        <ListItemText primary="OncoMX SPARQL Portal" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        component="a"
                        href="http://www.inode-project.eu:18081/test/galaxies.html"
                        onClick={() => onClick()}
                    >
                        <ListItemText primary="DORA The Explorer (Galaxy exploration)" />
                    </ListItemButton>
                </ListItem>
                <Divider />
                {Object.values(Routes)
                    .filter(x => x.showOnSiteMap)
                    .map(x => (
                        <ListItemButton
                            key={x.path}
                            onClick={() => {
                                onClick();
                                dispatch(push(x.path));
                            }}
                        >
                            <ListItemIcon>
                                <Folder />
                            </ListItemIcon>
                            <ListItemText primary={x.label} />
                        </ListItemButton>
                    ))}
            </List>
        </Offset>
    );
};
